import { render, staticRenderFns } from "./scale-out-component.vue?vue&type=template&id=480928be&scoped=true&"
import script from "./scale-out-component.vue?vue&type=script&lang=js&"
export * from "./scale-out-component.vue?vue&type=script&lang=js&"
import style0 from "./scale-out-component.vue?vue&type=style&index=0&id=480928be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480928be",
  null
  
)

export default component.exports